<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>

          <b-form-row>
            <b-col md="6">
              <b-form-group label="Ano / Mês">
                <b-form-input type="number" step="1" min="0" name="ym" v-model="item.ym" placeholder="Ano / Mês"  v-validate="'required'" :state="validateState('ym')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('ym') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Spreads" >
                <b-form-select :options="lists.yesNo" name="spreads" v-model="item.spreads" placeholder="Estado"  v-validate="'required'" :state="validateState('spreads')" ></b-form-select>

                <b-form-invalid-feedback>
                  {{ errors.first('code') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>
          <modal-select modal="independent-operators-modal" v-validate="'required'" name="independent_operator_id" v-bind:readonly="item.id>0" v-bind:item-id="item.independent_operator_id" v-bind:item-name="item.operator.data.name" v-on:select-item="selectOperator"  :state="validateState('independent_operator_id')"  ></modal-select>

          <b-form-row>
            <b-col md="4">
              <b-form-group label="Sellin Top10">
                <b-form-input type="number" step="0.01" min="0" name="sellin1" v-model="item.sellin1" placeholder="Sellin Top10"  v-validate="'required'" :state="validateState('sellin1')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('sellin1') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Sellin Total">
                <b-form-input type="number" step="0.01" min="0" name="sellin2" v-model="item.sellin2" placeholder="Sellin Total"  v-validate="'required'" :state="validateState('sellin2')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('sellin2') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>



          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'independentObjectives.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>


      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Debug </strong>
          </div>
          <pre>{{ item }}</pre>

        </b-card>
      </b-col>
      <!--/.col-->

    </div>
  </form>

</div>
</template>

<script>
import lists from '@/components/States.js'
export default {
  name: 'BestofObjectiveEdit',
  props: ['id'],
  components: {  },
  data() {
    return {
      lists: lists,
      dataLoaded: false,
      item: {
        operator: {
          data: {
            name: '',
            id: null
          }
        },
        sellin1: 0,
        sellin2: 0,
        sellin3: 0
      }
    }
  },
  methods: {
    selectOperator(e) {
      this.item.independent_operator_id = e.item.id
      this.item.operator.data = e.item
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('scorecard-independents/objectives' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'independentObjectives.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(response.message, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('scorecard-independents/objectives', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'independentObjectives.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('scorecard-independents/objectives' + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.dataLoaded = true
          if(!this.item.operator) {
            this.item.operator = {
              data: {}
            }
          }
        })
        .catch(response => {
          this.$bvToast.toast(response.message, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'independentObjectives.index'
          })
        })
    } else {
      this.dataLoaded = true
    }
  }
}
</script>
